import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '@app/core/models/user.model';
import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
	selector: 'punchUserPin',
	templateUrl: './punch-user-pin.component.html',
	styleUrls: ['./punch-user-pin.component.scss'],
})

export class PunchUserPinComponent implements OnInit {
	public user: User;
	public punchedIn: boolean;

	public date: string;

	public pinMask: any[] = [/\d/, /\d/, /\d/, /\d/];

	public form: FormGroup;

	constructor(
		private dialogRef: MatDialogRef<PunchUserPinComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private formBuilder: FormBuilder,
	) {

	}

	public get pinValid(): boolean {
		return this.form.get('pin').value?.replace('_', '').length === 4;
	}

	public get confirmationValid(): boolean {
		return this.form.get('confirmation').value;
	}

	public ngOnInit(): void {
		this.initForm();
		this.user = this.data.user;
		this.punchedIn = this.data.punchedIn;

		this.date = moment().format('LLL');
	}

	public punch(): void {
		if (!this.confirmationValid || !this.pinValid) {
			return;
		}
		this.dialogRef.close({success: true, pinCode: this.form.value.pin});
	}

	public closeModal(): void {
		this.dialogRef.close();
	}

	private initForm(): void {
		this.form = this.formBuilder.group({
			pin: [null, Validators.required],
			confirmation: [false],
		});
	}
}
